import { render } from "./documents_editor_redact.vue?vue&type=template&id=0cff391a"
import script from "./documents_editor_redact.vue?vue&type=script&lang=js"
export * from "./documents_editor_redact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__